import React from 'react';

import Skeleton from '@atlaskit/skeleton';

export const UsersFieldSkeleton = (): React.JSX.Element => {
	return <Skeleton testId="users-field-skeleton" width="250px" height="16px" isShimmering />;
};
